<script>
import { mapActions } from 'vuex';
// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/es';
import Catalogue from '@/services/catalogue';
import request from '@/services/request'

export default {
    components: {
        // DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            pagosAnteriores: [
                { date: '2025-05-01', amount: 500, type_payment_id: 'efectivo' },
                { date: '2025-05-03', amount: 300, type_payment_id: 'tarjeta' }
            ],
            form: {
                id: '',
                amount: '',
                type_payment_id: '',
                date: '2025-05-01'
            },
            bill: null,
        };
    },
    methods: {
        getTypePayment(type) {
            if (type.length == 1) {
                type = '0' + type;
            }
            let result = this.catalogue.pay_bill.find(item => item.value == type);
            return result.name;
        },
        async guardarPago() {
            this.$swal({
                title: 'Crear complemento de pago',
                text: '¿ Seguro que quiere crear la complemento de pago ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Generar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/payment_plugin';
                    let data_form = new FormData();
                    data_form.append('id', this.form.id);
                    data_form.append('type_payment_id', this.form.type_payment_id);
                    data_form.append('amount', this.form.amount);
                    data_form.append('date', this.form.date);

                    try {
                        let { data } = await request.postMedia(_endpoint, data_form)
                        if (data) {
                            this.successNotification(data.message);
                            this.closedModal();
                            Event.$emit('event-show-bill-external-debv-list');
                        }
                    } catch (error) {
                        this.errors = {};
                        if (error.response) {
                            this.errors = await this.errorNotification(error);
                        }
                    }
                }
            });
        },
        closedModal() {
            this.form.amount = '';
            this.form.type_payment_id = '';
            // this.form.date = '';
            this.send = false;
            this.pagosAnteriores = [];
            this.$modal.hide('addPaymentAddOn');
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    computed: {
        totalPagado() {
            return this.bill.payment_plugin.reduce((sum, pay) => {
                return sum + parseFloat(pay.amount_pay || 0);
            }, 0);
        }
    },
    created() {
        Event.$on("event-show-addPaymentAddOn", async (bill) => {
            this.bill = bill;
            this.form.id = bill.id;
            this.$modal.show('addPaymentAddOn');
        });
    },
}
</script>
<template>
    <modal name="addPaymentAddOn" :width="'80%'" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-outline-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i>
        </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Complementos de pagos</h5>
        </div>

        <!-- Body -->
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Método</th>
                                <th>Monto</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="bill.payment_plugin.length == 0">
                            <tr>
                                <td colspan="4" class="text-center">
                                    Sin pagos 
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(pay, index) in bill.payment_plugin" :key="index">
                                <td>{{ pay.created_at | toDateTime }}</td>
                                <td>{{ getTypePayment(pay.payment_id) }}</td>
                                <td>{{ pay.amount_pay | toCurrency }}</td>
                                <td class="text-center">
                                    <a :href="`${globalUrlFiles}/file/payment_plugin/${pay.id}/pdf`"
                                        v-if="pay" target="_blank"
                                        class="btn btn-outline-info btn-sm m-1">
                                        <i class="fa-regular fa-file-pdf"></i> PDF
                                    </a>
                                    <a :href="`${globalUrlFiles}/file/payment_plugin/${pay.id}/xml`"
                                        v-if="pay" target="_blank"
                                        class="btn btn-outline-info btn-sm m-1">
                                        <i class="fa-regular fa-file"></i> XML
                                    </a>
                                </td>

                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    Total:
                                </td>
                                <td>
                                    {{ bill.total | toCurrency }}
                                </td>
                                <td>
                                    {{ totalPagado | toCurrency }}
                                </td>
                                <td></td>
                            </tr>
                            <tr class="table-secondary">
                                <td colspan="2">
                                </td>                              
                                <td>
                                    {{ bill.total - totalPagado | toCurrency }}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="col-12">
                    <hr>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label> Método de pago : </label>
                        <select class="form-control" v-model="form.type_payment_id">
                            <option value="">Seleccione</option>
                            <option v-for="(pay, index) in catalogue.pay_bill" :value="pay.value" :key="index">{{
                                pay.value }} - {{ pay.name }}</option>
                        </select>
                        <div v-if="errors && errors.type_payment_id" class="text-danger">{{ errors.type_payment_id[0] }}
                        </div>
                    </div>
                </div>
                <!-- <div class="col-md-5">
                    <div class="form-group">
                        <label>Fecha</label>
                        <date-picker v-model="form.date" valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}
                        </div>
                    </div>
                </div> -->
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Monto</label>
                        <money class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr>
                    <button type="submit" @click="guardarPago()" class="btn float-right btn-outline-success">
                        <spam v-if="send">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                        </spam>
                        <spam v-else>
                            <i class="fas fa-save"></i> Guardar
                        </spam>
                    </button>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>


            </div>
        </div>


    </modal>
</template>